module.exports = __webpack_public_path__ + "img/content-img-3.ca080c4c.jpg";